import {IScriptConnection} from 'core/decorators/connectScript';
import {ScriptConnectionError} from 'core/exceptions/ScriptConnectionError';
import {NEXT_PUBLIC_ONLINE_CHAT_ID} from 'core/helpers/env';
import {connectOnlineChat} from 'modules/online-chat/helpers/connectOnlineChat';
import {IS_DEV} from 'core/constants';

export class OnlineChatService {
    private static readonly scriptUrl = `https://msksc02.sfcs.cc/widget/file?filename=widget.js&id=${NEXT_PUBLIC_ONLINE_CHAT_ID}`;

    public static async connect(): Promise<IScriptConnection> {
        if (!NEXT_PUBLIC_ONLINE_CHAT_ID || IS_DEV) {
            return Promise.reject(new ScriptConnectionError(this.scriptUrl));
        }
        return connectOnlineChat(this.scriptUrl);
    }

    public static openChat(): void {
        const chatEl = document.getElementById('chat-24-popup-7');
        if (chatEl) {
            setTimeout(() => {
                chatEl.style.opacity = '1';
                chatEl.style.display = 'block';
                chatEl.style.visibility = 'visible';
            }, 0);
        }
    }
}
